export default {
  writeAName: 'Escribe un nombre',
  loading: 'Cargando ingredientes',
  headers: {
    name: 'Nombre',
    baseUnit: 'Unidad',
    price: 'Precio',
    quantity: 'Cantidad',
    actions: 'Acciones'
  },
  labels: {
    product: 'Producto',
    provider: 'Proveedor',
    quantity: 'Cantidad',
    unit: 'Unidad'
  },
  actions: {
    save: 'Guardar',
    remove: '¿Borrar {name}?'
  }
}
